























import Vue from 'vue'
import { db } from '@/firebaseInit'

export default Vue.extend({
  name: 'NavBar',
  data: () => ({
    loading: false,
    items: [],
    model: null,
    search: null
  }),
  watch: {
    search(val) {
      if (this.items.length > 0) return
      this.loading = true

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      db.collection('documentTypes')
        .get()
        .then((q: any) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.items = q.docs.map((doc: any) => doc.data().name)
        })
        .finally(() => (this.loading = false))
    }
  }
})
